import React from 'react';
import { css } from '@emotion/core';
import { Desktop, Tablet } from '../../constants/responsive';
import Slider from 'react-slick';
import Arrow from '../../svgs/smart-stock/Arrow.svg';
import Blank from '../../components/Blank';
import ScrollContainer from 'react-indiana-drag-scroll';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';
// 上按钮
const MoveUp = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      onClick={onClick}
      className={className}
      style={style}
      css={css`
        ${Tablet} {
          display: none !important;
        }
        ${Desktop} {
          display: block !important;
          left: 430.3px;
          margin-top: -55px;
        }
      `}
    >
      <Arrow
        width={40}
        css={css`
          transform: translate(-3px, -55px) rotate(-90deg);
          z-index: 5;
        `}
      />
    </div>
  );
};
// 下按钮
const MoveDown = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      onClick={onClick}
      className={className}
      style={{ ...style }}
      css={css`
        ${Tablet} {
          display: none !important;
        }
        ${Desktop} {
          display: block !important;
          right: -59.2px;
          margin-top: 38px;
        }
      `}
    >
      <Arrow
        width={40}
        css={css`
          transform: translate(-3px, -55px) rotate(90deg);
          z-index: 5;
        `}
      />
    </div>
  );
};

const TeamSayCard = ({ name = 'Tiffany' }) => {
  const intl = useIntl();
  return (
    <div
      className='team-say-card'
      css={css`
        // 不加flex，头像和内容框的z-index没有起到正确的作用
        display: flex;
        flex-direction: column;
        margin-left: 15px;
        ${Tablet} {
          opacity: 0.5;
          margin-bottom: 65px;
          margin-left: 0;
        }
        ${Desktop} {
          margin-bottom: 35px;
        }
      `}
    >
      {/* 头像 */}
      <div
        css={css`
          z-index: 6;
          border-radius: 50%;
          width: 100px;
          height: 100px;
          border: 4px solid #ffffff;
          margin-left: 81px;
          background: url(/career/what-team-say/${name}.png) no-repeat;
          background-size: cover;
          background-size: cover;
          background-position: center;
          ${Tablet} {
            width: 100px;
            height: 100px;
            border: 4px solid #ffffff;
            margin-left: 81px;
          }
          ${Desktop} {
            width: 118.8px;
            height: 119px;
            border: 5px solid #ffffff;
            margin-left: 19px;
          }
        `}
      ></div>
      {/* 内容 */}
      <div
        css={css`
          z-index: 3;
          box-shadow: 0 3px 10px 2px rgba(0, 0, 0, 0.05);
          background: #ffffff;
          border-radius: 15px;
          width: 263px;
          height: 248px;
          margin-top: -48px;
          padding: 81px 17px 0 16px;
          position: relative;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          ${Tablet} {
            width: 263px;
            height: 248px;
            margin-top: -48px;
            padding: 81px 17px 0 16px;
            position: relative;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          ${Desktop} {
            width: 389.5px;
            height: 248px;
            margin-top: -56px;
            padding: 81px 24px 0 33px;
            position: relative;
            text-align: left;
            align-items: flex-start;
          }
        `}
      >
        <div
          css={css`
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.29;
            ${Tablet} {
              font-size: 14px;
              font-weight: 500;
              line-height: 1.29;
            }
            ${Desktop} {
              font-size: 18px;
              font-weight: 500;
              line-height: 1.33;
            }
          `}
        >
          {intl.formatMessage({ id: `career.what-team-say.${name}.say` })}
        </div>
        <div
          css={css`
            color: #000000;
            position: absolute;
            bottom: 14px;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.29;
            b {
              font-weight: 500;
            }
            ${Tablet} {
              position: absolute;
              bottom: 14px;
              font-size: 14px;
              font-weight: normal;
              line-height: 1.29;
              b {
                font-weight: 500;
              }
            }
            ${Desktop} {
              position: absolute;
              bottom: 28px;
              font-size: 14px;
              font-weight: normal;
              line-height: 1.43;
              b {
                font-weight: bold;
              }
              br {
                display: none;
              }
            }
          `}
        >
          <FormattedHTMLMessage id={`career.what-team-say.${name}.info`} />
        </div>
      </div>
    </div>
  );
};

const CareerTeamSay = () => {
  const intl = useIntl();
  return (
    <div
      css={css`
        width: 100%;
        background: #f2f2f2;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        ${Tablet} {
          height: 661px;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        }
        ${Desktop} {
          height: 726px;
        }
      `}
    >
      <Blank height={[100, 0, 0]} />
      {/* 滚动卡片 - WEB、IPAD端 */}
      <div>
        <Slider
          className='center'
          vertical
          verticalSwiping
          centerMode
          slidesToShow={3}
          prevArrow={<MoveUp />}
          nextArrow={<MoveDown />}
          css={css`
            display: none;
            ${Tablet} {
              display: block;
              width: 263px;
              height: 100%;
              .slick-list {
                padding: 23px 0px !important;
              }
              .slick-center {
                .team-say-card {
                  opacity: 1;
                }
              }
            }
            ${Desktop} {
              width: 389.5px;
              height: 100%;
              .slick-list {
                padding: 0px 0px !important;
              }
            }
          `}
        >
          <TeamSayCard name='Tiffany' />
          <TeamSayCard name='Sarah' />
          <TeamSayCard name='Wanghao' />
          <TeamSayCard name='Anson' />
          <TeamSayCard name='Brandon' />
          <TeamSayCard name='Victor' />
          <TeamSayCard name='Catherine' />
          <TeamSayCard name='Maria' />
        </Slider>
      </div>
      {/* 卡片外文字 */}
      <Blank width={[0, 69, 115.8]} />
      <div
        css={css`
          padding: 0 8px;
          text-align: center;
          ${Tablet} {
            padding: 0;
            text-align: left;
          }
        `}
      >
        <div
          css={css`
            color: #000000;
            font-size: 22px;
            font-weight: 500;
            line-height: 0.91;
            margin-bottom: 16px;
            ${Tablet} {
              font-size: 22px;
              font-weight: 500;
              line-height: 0.91;
              margin-bottom: 27px;
            }
            ${Desktop} {
              font-size: 36px;
              font-weight: 500;
              line-height: 0.92;
              margin-bottom: 31px;
            }
          `}
        >
          {intl.formatMessage({ id: `career.what-team-say.title` })}
        </div>
        <div
          css={css`
            color: #000000;
            font-size: 18px;
            font-weight: normal;
            line-height: 1.33;

            ${Tablet} {
              font-size: 18px;
              font-weight: normal;
              line-height: 1.33;
              max-width: 338px;
            }
            ${Desktop} {
              font-size: 24px;
              font-weight: normal;
              line-height: 1.38;
              max-width: 491.3px;
            }
          `}
        >
          {intl.formatMessage({ id: `career.what-team-say.description` })}
        </div>
      </div>
      <Blank height={[54, 0, 0]} />
      {/* 滚动卡片 MOBILE端 */}
      <ScrollContainer
        css={css`
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 0 15px 10px 0;
          ${Tablet} {
            display: none;
          }
        `}
      >
        <TeamSayCard name='Tiffany' />
        <TeamSayCard name='Sarah' />
        <TeamSayCard name='Wanghao' />
        <TeamSayCard name='Anson' />
        <TeamSayCard name='Brandon' />
        <TeamSayCard name='Victor' />
        <TeamSayCard name='Catherine' />
        <TeamSayCard name='Maria' />
      </ScrollContainer>
      <Blank height={[90, 0, 0]} />
    </div>
  );
};

export default CareerTeamSay;
